import { numberFormatter } from '../numberFormatter';
import { FormatRule, SignOptions } from '../types';
import { insertCurrency } from '../utils/insertCurrency';

interface MoneyFormatter {
  money: { value: number; currency?: string };
  /**
   * Правила форматирования чисел описываются на странице:
   * https://wiki.unitedtraders.team/pages/viewpage.action?pageId=70189302
   */
  rule?: FormatRule;
  sign?: SignOptions;
  locale?: string;
}

export const moneyFormatter = ({
  money: { value, currency },
  rule = 'as is',
  locale,
  sign = 'default'
}: MoneyFormatter) => {
  if (!locale && typeof window !== 'undefined') {
    locale = window.navigator.language;
  }

  const { formatted: formattedValue, rounded } = numberFormatter({
    value,
    rule,
    sign,
    locale
  });

  const valueWithCurrencySymbol = currency
    ? insertCurrency({
        locale,
        formattedValue,
        currencyCode: currency
      })
    : formattedValue;

  return { formatted: valueWithCurrencySymbol, rounded };
};
